<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>校安輔導人員職責分配</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/"><i class="fa fa-home"></i></a>
          </li>
          <li><span>校安輔導人員職責分配</span></li>
        </ol>
      </div>
    </header>
    <div class="col-md-12">
      <section class="panel">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">校安輔導人員職責分配</h1>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <label class="col-sm-3 ">輔導人員(工號)<span class="required">*</span></label>
            <div class="col-sm-9">
              <label><input type="text" size="15" v-model="form.tchId" @change.prevent="teacherSearch" /></label>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">輔導人員(姓名)<span class="required">*</span></label>
            <div class="col-sm-9">
              <label>{{tchName}}</label>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">學年度<span class="required">*</span></label>
            <div class="col-sm-9">
                <select v-model="form.schYearTerm">
                  <option :value="null">請選擇</option>
                  <option v-for="item in schYearTermList" :key="item" :value="item.replace('/', '')">{{item}}</option>
                </select>　
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">輔導系所<span class="required">*</span></label>
            <div class="col-sm-9" ref="checkboxList">
              <div class="checkbox-custom chekbox-primary" style="display: block;" v-for="(item, index) in deptList" :key="index">
                <input :id="'dept_' + item.code" type="checkbox" :value="item.code" v-model="form.deptList" />
                <label :for="'dept_' + item.code">{{item.value}}</label>　　
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
    <div class="col-md-12">
      <table width="100%" style="margin:6px;">
        <tr>
          <td align="right"><a href="#" @click.prevent="formClear" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;">重　　填</a>　</td>
          <td align="left"><a href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">儲　　存</a></td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      schYearTermList: [],
      deptList: [],
      tchName: "--",
      form: {
          tchId: "",
          schYearTerm: null,
          deptList: []
      }
    };
  },
  mounted() {
    let d = this.nowDate();
    let nowSchYear = d.getFullYear() - 1911;
    for (let i = nowSchYear; i >= 108; i--) {
      if (i == nowSchYear) {
        let month = d.getMonth() + 1;
        if (month < 8) continue;
        else this.schYearTermList.push(i.toString() + "/1");
      } else {
        this.schYearTermList.push(i.toString() + "/2");
        this.schYearTermList.push(i.toString() + "/1");
      }
    }
    this.$http.get("/api/shared/dept-list").then(a => {
      this.deptList = a.body;
    });
  },
  methods: {
    teacherSearch() {
      this.form.tchId = this.form.tchId.trim();
      if (this.form.tchId) {
        this.$http.get("/api/shared/teacher-name/" + this.form.tchId).then(a => {
          if (a.body)
            this.tchName = a.body;
          else {
            alert("查無此工號資料");
            this.tchName = "--";
          }
        });
      } else {
        this.tchName = "--";
      }
    },
    formClear() {
      this.tchName = "--";
      this.form.tchId = "";
      this.form.schYearTerm = null;
      this.form.deptList = [];
    },
    formSubmit() {
      if (this.form.tchId == "" || this.tchName == "--") {
        alert("請先取得輔導人員資料");
        return false;
      }
      if (this.checkForm() == false) return;
      this.$http.post("/api/tenancyInstructor/create", this.form).then(a => {
        if (a.body.status) {
          alert("新增成功");
          this.$router.push("/tenancy-instructor");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    checkForm() {
      let msg = "";
      if (this.form.schYearTerm == null) msg += "『學年度』、";
      if (!(Array.isArray(this.form.deptList) && this.form.deptList.length)) msg += "『輔導系所』、";
      if (msg != "") {
        alert(msg.substr(0, msg.length - 1) + " 尚未選取");
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
</style>